'use strict';

import React from 'react';
import classnames from 'classnames';

import Logger from '../../utils/Logger';

import { injectIntl, FormattedMessage } from 'react-intl';

const { id: module_id } = module;
const logger = Logger(module_id);

class FormField extends React.Component {
  handleInputChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    if (this.props.handleValueChange) {
      this.props.handleValueChange({
        [name]: value,
      });
    }
  };

  handleRadioChange = (event) => {
    const target = event.target;
    let value = target.name;

    //convert boolean string values to actual boolean..
    if (value && typeof value === 'string') {
      if (value === 'true') {
        value = true;
      } else if (value === 'false') {
        value = false;
      }
    }

    logger.debug(
      'handled radio change. resolved value is ',
      value,
      typeof value
    );

    if (this.props.handleValueChange) {
      this.props.handleValueChange({
        [this.props.val.name]: value,
      });
    }
  };

  /* buttons are currently handled outside forms */
  handleButtonPush = (event) => {};

  mapRows(rows) {
    return rows
      ? rows.split('\n').map((row, index) => <p key={index}>{row}</p>)
      : null;
  }

  createInput(currentValue) {
    let { val } = this.props;
    let { disabled, label } = val;

    let labelContent = this.mapRows(this.props.val.label);
    /*let inputClassNames=classnames({""})*/
    let inputOptions = {};
    if (disabled) {
      inputOptions['data-uneditable'] = 'data-uneditable';
    }

    return (
      <label className="control-label" htmlFor={name}>
        {labelContent}
        <div className="controls">
          <input
            id={name}
            type="text"
            disabled={disabled}
            name={name}
            ref={this.props.val.ref}
            value={currentValue.toString()}
            onChange={this.handleInputChange}
          />
        </div>
      </label>
    );
  }

  /*  createStatus(currentValue) {
    return <div>{currentValue}</div>;
  }*/

  createRadio(currentValue) {
    let { val, intl } = this.props;
    let { values } = val;

    return (
      <fieldset>
        {values.map((radioValue) => {
          let { value, id, label } = radioValue;

          // in multi select radio the ref is in the containing element. here we can get selected option
          return (
            <div
              className="radio-block"
              key={value.toString()}
              ref={this.props.val.ref}
            >
              <label htmlFor={radioValue.id.toString()}>
                <input
                  aria-label={intl.formatMessage({ id: 'select' })}
                  type="radio"
                  id={id.toString()}
                  name={value.toString()}
                  value={value.toString()}
                  checked={
                    currentValue.toString() === radioValue.value.toString()
                  }
                  onChange={this.handleRadioChange}
                />
                <span className="radio-check" />
                <span className="radio-label">
                  <FormattedMessage id={label} />
                </span>
              </label>
            </div>
          );
        })}
      </fieldset>
    );
  }

  createButton() {
    let { val } = this.props;
    let { action, text } = val;

    return (
      <button
        className="ot-button ot-button--big"
        onClick={() => this.handleButtonPush(action)}
      >
        {text}
      </button>
    );
  }

  render() {
    let { val, existingVal } = this.props;
    let { type, defaultValue, description } = val;

    let currentValue =
      existingVal !== undefined && existingVal !== null
        ? existingVal
        : defaultValue;

    let input = null;

    switch (type) {
      case 'input':
        input = this.createInput(currentValue);
        break;
      case 'radio':
        input = this.createRadio(currentValue);
        break;
      case 'button':
        input = this.createButton();
        break;
      /*case "status":
        input = this.createStatus(currentValue);
        break;*/
      default:
        break;
    }

    const controlGroupClassnames = classnames({
      'control-group': true,
      'inline-label': type === 'radio',
    });

    let descriptionRows = this.mapRows(description);

    return (
      <div className={this.props.val.className}>
        <div className={controlGroupClassnames}>
          {input}
          <div className="info">{descriptionRows}</div>
          {type === 'html' && (
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
          )}
        </div>
      </div>
    );
  }
}

export default injectIntl(FormField);
